import { useCallback } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import type { HeadlineOverlineTimerProps } from './types';
import { bridge, isNil, isNotNil } from '../../../../utils';
import { useCountdown } from '../../../../hooks/useCountdown';
import { useOpenDeeplink } from '../../../../hooks';
import type { IScreensLogging } from '../../../../api/types';

export const HeadlineOverlineTimer = ({
  header,
}: HeadlineOverlineTimerProps) => {
  const { openDeeplink } = useOpenDeeplink();
  const { timeText: timerText } = useCountdown(header?.item.timer?.finished_at);

  const remainingHour = header?.item.timer?.finished_at
    ? Math.max(0, (new Date(header.item.timer.finished_at).getTime() - Date.now()) / 3600000)
    : 0;

  const handlePressBanner = useCallback(() => {
    if (isNil(header) || isNil(header.item.deeplink)) return;
    logClickMore({ logging: header.logging });
    openDeeplink(header.item.deeplink);
  }, [header, openDeeplink]);

  if (isNil(header)) return null;

  return (
    <Flex padding={{ top: 16, bottom: 8, horizontal: 16 }}>
      <Typography type="body4" color="content_primary">
        {header.item.overline}
      </Typography>
      {isNotNil(header.item.title) ? (
        <Flex margin={{ top: 2 }}>
          <Typography type="h3" color="content_primary">
            {header.item.title}
          </Typography>
        </Flex>
      ) : (
        isNotNil(timerText) && (
          <Flex margin={{ top: 2 }}>
            <Typography
              type="h3"
              color={
                remainingHour < 24
                  ? 'content_pink_primary'
                  : 'content_primary'
              }
            >
              {timerText}
            </Typography>
          </Flex>
        )
      )}
      {isNotNil(header.item.banner) && (
        <Flex
          margin={{ top: 8 }}
          backgroundColor="bg_secondary"
          borderRadius={8}
          padding={{ horizontal: 12, vertical: 12 }}
          onPress={handlePressBanner}
        >
          <Typography type="subtitle3" color="content_secondary">
            {header.item.banner.title}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};

const logClickMore = ({ logging }: { logging: IScreensLogging }) => {
  bridge.logAnalyticsEvent({
    name: 'CLICK_HEADLINE_OVERLINE_TIMER_MORE',
    analytics: logging.analytics,
    ably_only_log: logging.ably_only_log,
  });
};
